import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { API_URL } from '../utils/api';
import { Home, Search, PlusSquare, User, CalendarCheck, MessageCircle, Bell } from 'lucide-react';

export default function BottomNav() {
  const { user } = useAuth();
  const location = useLocation();
  const path = location.pathname;
  const [dmUnread, setDmUnread] = useState(0);
  const [notifUnread, setNotifUnread] = useState(0);

  useEffect(() => {
    if (!user) return;
    const fetchCounts = async () => {
      try {
        const [dm, notif] = await Promise.all([
          axios.get(`${API_URL}/api/dm/unread-count`, { withCredentials: true }),
          axios.get(`${API_URL}/api/notifications/unread-count`, { withCredentials: true })
        ]);
        setDmUnread(dm.data.count || 0);
        setNotifUnread(notif.data.count || 0);
      } catch {}
    };
    fetchCounts();
    const interval = setInterval(fetchCounts, 10000);
    return () => clearInterval(interval);
  }, [user, path]);

  if (['/login', '/register', '/admin'].includes(path)) return null;

  const scrollToBooking = () => {
    if (path === '/') {
      const el = document.getElementById('booking');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const allItems = [
    { to: '/', icon: Home, label: 'Anasayfa', active: path === '/' },
    { to: '/#booking', icon: CalendarCheck, label: 'Rezervasyon', active: false, onClick: scrollToBooking },
    { to: '/explore', icon: Search, label: 'Keşfet', active: path === '/explore' || path.startsWith('/user/') },
    ...(user ? [
      { to: '/notifications', icon: Bell, label: 'Bildirim', active: path === '/notifications', badge: notifUnread },
      { to: '/messages', icon: MessageCircle, label: 'Mesajlar', active: path.startsWith('/messages'), badge: dmUnread },
    ] : []),
    { to: user ? '/profile' : '/login', icon: User, label: 'Profil', active: path === '/profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-[#050505]/95 backdrop-blur-lg border-t border-white/10" data-testid="bottom-nav">
      <div className="max-w-2xl mx-auto flex items-center justify-around h-14">
        {allItems.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            onClick={item.onClick}
            className={`flex flex-col items-center gap-0.5 px-2 py-1.5 transition-colors relative ${item.active ? 'text-white' : 'text-white/40 hover:text-white/70'}`}
            data-testid={`bottom-nav-${item.label.toLowerCase().replace(/[ş]/g,'s').replace(/[ö]/g,'o').replace(/[ü]/g,'u').replace(/[ç]/g,'c').replace(/[ğ]/g,'g').replace(/[ı]/g,'i').replace(/\s/g, '-')}`}
          >
            <div className="relative">
              <item.icon className={`w-5 h-5 ${item.active ? 'stroke-[2.5]' : ''}`} />
              {item.badge > 0 && (
                <span className="absolute -top-1.5 -right-2 min-w-[14px] h-[14px] bg-red-500 rounded-full flex items-center justify-center text-[8px] text-white font-bold px-0.5">{item.badge > 9 ? '9+' : item.badge}</span>
              )}
            </div>
            <span className="text-[8px] uppercase tracking-wider">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
